<template>
  <div id="nav-root" class="v-flex">
    <div v-if="!$route.meta.hideNav" id="nav-container" class="h-flex">
      <Sidebar class="nav-sidebar" />
      <!-- BP-2915: the reports flyout mounts here, not inside Sidebar, because
           .nav-sidebar clips its overflow. -->
      <ReportsFlyout v-if="isReportsFlyoutOpen" />
      <b-card
        id="nav-window"
        :body-class="['v-flex', ...cardBodyClass]"
        class="v-flex"
      >
        <template #header>
          <Navbar />
        </template>
        <slot />
      </b-card>
    </div>
    <slot v-else />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

const Sidebar = () => import('@/components/Navigation/Sidebar/Sidebar.vue')
const Navbar = () => import('@/components/Navigation/Navbar/Navbar.vue')
const ReportsFlyout = () =>
  import('@/components/Navigation/Sidebar/ReportsFlyout.vue')

type ClassName = string | string[]

Component.registerHooks(['beforeRouteUpdate'])
@Component({
  components: {
    Sidebar,
    Navbar,
    ReportsFlyout
  }
})
export default class ContainerWithNav extends Vue {
  cardBodyClass: ClassName = []

  get isReportsFlyoutOpen() {
    return this.$store.getters.isReportsFlyoutOpen
  }

  created() {
    this.$eventBus.on('setCardBodyClass', (className: ClassName) => {
      Array.isArray(className)
        ? (this.cardBodyClass = className)
        : (this.cardBodyClass = [className])
    })
  }

  destroyed() {
    this.$eventBus.off('setCardBodyClass')
  }
}
</script>

<style lang="scss" scoped>
#nav-container {
  // Containing block for the reports flyout layer.
  position: relative;

  height: 100vh;
}

.nav-sidebar {
  max-width: $sidebar-width;
  height: 100vh;
  overflow: hidden;

  background: linear-gradient(340deg, $dark-blue 0%, $blue 100%);
}

#nav-window {
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;

  background: white;
  border-radius: 0;

  .card-header {
    padding: 0;
  }

  .card-body {
    width: 100%;
    padding: 0;

    .v-flex {
      flex: 1;
    }
  }
}

.customer-detail-page {
  overflow: visible;

  #customer_page {
    width: 100px;
  }
}
</style>
